import React from "react";
import { APIProvider, Map, AdvancedMarker, InfoWindow } from "@vis.gl/react-google-maps";
import { Box, Typography } from "@mui/material";
import OrganizationLocationPin from "./OrganizationLocationPin";

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const MAP_ID = process.env.REACT_APP_GOOGLE_MAPS_MAP_ID;

// Default center on Hong Kong
const DEFAULT_CENTER = { lat: 22.3664, lng: 114.1095 };
const DEFAULT_ZOOM = 11;

export default function OrganizationLocationMap({ organizations = [] }) {
    const [selectedId, setSelectedId] = React.useState(null);

    const validOrgs = organizations.filter(
        (org) => org.lat != null && org.lng != null && org.lat !== "" && org.lng !== ""
    );

    const selectedOrg = validOrgs.find((org) => org.id === selectedId) ?? null;

    return (
        <APIProvider apiKey={API_KEY}>
            <Box sx={{ width: "100%", height: "100%" }}>          
            <Map
                mapId={MAP_ID}
                defaultCenter={DEFAULT_CENTER}
                defaultZoom={DEFAULT_ZOOM}
                style={{ width: "100%", height: "100%" }}
                gestureHandling="greedy"
                disableDefaultUI={false}
                streetViewControl={false}
                colorScheme="DARK"
            >
                {validOrgs.map((org) => (
                    <AdvancedMarker
                        key={org.id}
                        position={{ lat: parseFloat(org.lat), lng: parseFloat(org.lng) }}
                        onClick={() => setSelectedId(org.id)}
                        title={org.name_en}
                    >
                        <OrganizationLocationPin org={org} />
                    </AdvancedMarker>
                ))}

                {selectedOrg && (
                    <InfoWindow
                        position={{
                            lat: parseFloat(selectedOrg.lat),
                            lng: parseFloat(selectedOrg.lng),
                        }}
                        onCloseClick={() => setSelectedId(null)}
                    >
                        <Box sx={{ px: 0.5, py: 0.25, maxWidth: 200 }}>
                            <Typography variant="subtitle2" fontWeight={700}>
                                {selectedOrg.name_en}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {selectedOrg.name_zh}
                            </Typography>
                        </Box>
                    </InfoWindow>
                )}
            </Map>
            </Box>
        </APIProvider>
    );
}
